import { salesVmo2ThemeVariables } from './sales-vmo2-theme-variables';
import { color, fontFamily } from './variable-constants';

export const vmo2ThemeVariables = {
  ...salesVmo2ThemeVariables,

  '--tertiary-color': color.vmBlue,
  '--tertiary-shadow': color.shadowBlue,

  '--text-h1-line-height': '2.8125rem',
  '--text-h1-letter-spacing': 'normal',
  '--text-h1-line-height-md': '3.4375rem',
  '--text-h1-letter-spacing-md': 'normal',

  '--text-h1-secondary-line-height': '3.75rem',

  '--text-h2-font-family': fontFamily.vmAeonikProLight,
  '--text-h2-line-height': '1.6875rem',
  '--text-h2-letter-spacing': 'normal',
  '--text-h2-font-family-md': fontFamily.vmAeonikProLight,
  '--text-h2-line-height-md': '2.8125rem',
  '--text-h2-letter-spacing-md': 'normal',

  '--text-h2-secondary-line-height': '2.25rem',

  '--text-h3-font-family': fontFamily.vmAeonikProRegular,
  '--text-h3-font-size': '1.125rem',
  '--text-h3-line-height': '1.4375rem',
  '--text-h3-letter-spacing': 'normal',
  '--text-h3-font-family-md': fontFamily.vmAeonikProRegular,
  '--text-h3-font-size-md': '1.125rem',
  '--text-h3-line-height-md': '1.4375rem',
  '--text-h3-letter-spacing-md': 'normal',

  '--text-h4-font-family': fontFamily.vmAeonikProRegular,
  '--text-h4-line-height': '1.4375rem',
  '--text-h4-letter-spacing': 'normal',

  '--text-h4-tertiary-font-size': '1.25rem',
  '--text-h4-quaternary-font-family': fontFamily.vmAeonikProBold,
  '--text-h4-quinary-font-family': fontFamily.vmAeonikProMedium,

  '--text-h5-font-family': fontFamily.vmAeonikProMedium,
  '--text-h5-line-height': '1.25rem',
  '--text-h5-letter-spacing': 'normal',

  '--text-h5-tertiary-font-family': fontFamily.vmAeonikProBold,

  '--body-secondary-font-family': fontFamily.vmAeonikProRegular,

  '--body-quaternary-font-family': fontFamily.vmRobotoRegular,

  '--paragraph-font-family': fontFamily.vmAeonikProRegular,

  '--list-font-weight': 300,
  '--list-line-height': 1.5,
  '--list-color': color.grey80,
  '--list-secondary-color': color.vmRed,

  '--text-book-secondary-font-family': fontFamily.vmRobotoMedium,
  '--text-book-tertiary-font-family': fontFamily.vmRobotoMedium,

  '--text-bold-secondary-font-weight': 500,
  '--text-bold-tertiary-font-family': fontFamily.vmRobotoRegular,
  '--text-bold-quaternary-font-family': fontFamily.vmAeonikProMedium,

  '--text-accordion-title-bar-font-family': fontFamily.vmAeonikProMedium,

  '--text-hero-title-font-family': fontFamily.vmAeonikProBold,
  '--text-hero-title-font-size': '1.875rem',
  '--text-hero-title-line-height': '2.5rem',
  '--text-hero-title-font-size-md': '2.5rem',
  '--text-hero-title-line-height-md': '3.75rem',
};
